/**
 * FormikDirtyReporter — zero-UI helper that tunnels Formik dirty state
 * up to a parent that owns a render-prop <Formik> and can't access
 * innerRef.dirty directly before the first render.
 *
 * Mount it inside a <Form> (or any Formik context) and pass an
 * onDirtyChange callback; it calls the callback whenever dirty changes.
 *
 * Contains:
 * - FormikDirtyReporter — effect-only component (default export)
 */
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

export default function FormikDirtyReporter({ onDirtyChange, commandRequired = false, onCommandRequiredChange }) {
  const { dirty } = useFormikContext();

  useEffect(() => {
    onDirtyChange(dirty);
  }, [dirty, onDirtyChange]);

  useEffect(() => {
    onCommandRequiredChange?.(commandRequired);
  }, [commandRequired, onCommandRequiredChange]);

  return null;
}

FormikDirtyReporter.propTypes = {
  onDirtyChange: PropTypes.func.isRequired,
  commandRequired: PropTypes.bool,
  onCommandRequiredChange: PropTypes.func,
};
